import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://mechelenbeach.be";
const DEFAULT_OG_IMAGE =
  "https://mechelenbeach.be/images/og-image-mechelen-beach-2026-v4.jpg";

function setMeta(name, content, attr = "name") {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function Seo({ title, description, image, noindex = false }) {
  const { pathname } = useLocation();

  useEffect(() => {
    const canonical = `${SITE_URL}${pathname === "/" ? "" : pathname}`;
    if (title) {
      document.title = title;
      setMeta("og:title", title, "property");
      setMeta("twitter:title", title);
    }
    if (description) {
      setMeta("description", description);
      setMeta("og:description", description, "property");
      setMeta("twitter:description", description);
    }
    setMeta("robots", noindex ? "noindex, nofollow" : "index, follow");
    setLink("canonical", canonical);
    setMeta("og:url", canonical, "property");
    setMeta("og:type", "website", "property");
    setMeta("og:site_name", "Mechelen Beach", "property");
    const ogImg = image || DEFAULT_OG_IMAGE;
    setMeta("og:image", ogImg, "property");
    setMeta("og:image:secure_url", ogImg, "property");
    setMeta("og:image:type", "image/jpeg", "property");
    setMeta("og:image:width", "1200", "property");
    setMeta("og:image:height", "630", "property");
    setMeta("og:image:alt", "Mechelen Beach 2026", "property");
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:image", ogImg);
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [title, description, image, noindex, pathname]);

  return null;
}
